
// ============================= DEPLOYMENT CONFIGURATION =============================
// Configure these constants for each deployment:
//
// LOCAL DEVELOPMENT:
//   - DEBUG = true
//   - HEROKU_ENVIRONMENT = (doesn't matter, DEBUG overrides)
//   → ENVIRONMENT will be "dev"
//   → Uses DEBUG_SERVER_ORIGIN, Admin Panel visible
//
// QA DEPLOYMENT:
//   - DEBUG = false
//   - HEROKU_ENVIRONMENT = QA
//   → ENVIRONMENT will be "qa"
//   → Uses QA_*_SERVER_ORIGIN, Admin Panel visible
//
// PRODUCTION DEPLOYMENT:
//   - DEBUG = false
//   - HEROKU_ENVIRONMENT = PROD
//   → ENVIRONMENT will be "prod"
//   → Uses PROD_*_SERVER_ORIGIN, Admin Panel HIDDEN
// ====================================================================================

export const DEBUG = false; // Set to true for local development
export const VERBOSE = false;


export const DEV: string = "dev";
export const QA: string = "qa";
export const PROD: string = "prod";

// IMPORTANT: Manually set to QA or PROD for Heroku deployments
export const HEROKU_ENVIRONMENT: string = PROD;

// Final environment: DEV if DEBUG is true, otherwise uses HEROKU_ENVIRONMENT
export const ENVIRONMENT: string = DEBUG ? DEV : HEROKU_ENVIRONMENT;

export const ENRICHYA: string = "enrichya";
export const AI4YOUTH: string = "ai4youth";
export const APP: string = ENRICHYA;




// ============================= Time export constants ================================
export const ONE_SECOND_MILLIS = 1000;
export const ONE_MINUTE_MILLIS = 60 * ONE_SECOND_MILLIS;

export const FIVE_MINUTE_MILLIS = 5 * ONE_MINUTE_MILLIS;
export const HALF_HOUR_MILLIS = 30 * ONE_MINUTE_MILLIS;
export const ONE_HOUR_MILLIS = 60 * ONE_MINUTE_MILLIS;

export const TWELVE_HOUR_MILLIS = 12 * ONE_HOUR_MILLIS;
export const ONE_DAY_MILLIS = 24 * ONE_HOUR_MILLIS;
// =============================================================================


export const USE_ASSISTANTS = false;

export const USE_CURRENT_SLIDE_CONTEXT_ONLY = true; // When true, AI responses use only current slide context/transcript instead of full session


// Good Voices: 
// -- Female: Yan, Jenny, Aria
// -- Male: Roger, Steffan

// Instructor Info
export const INSTRUCTOR_NAME = "Jenny";
export const INSTRUCTOR_PROFILE_PIC_SRC = require( "../assets/instructor_female_1.png" );
export const IDLE_INSTRUCTOR_VIDEO = "IdleInstructorAnimation.mp4";

// Error Handling
export const PURCHASE_NOT_FOUND_IMAGE = require("../assets/errorOccurred.png");// "purchaseNotFound.png"; // TODO: Not used right now (no reason)
export const ERROR_OCCURRED_IMAGE = "errorOccurred.png";

// Timeouts
export const LECTURE_SLIDE_PAUSE_BEFORE_WRAP_UP = 1000; // 1 Seconds
export const MIN_SILENCE_BEFORE_NEXT_SPEAK = 5000; // 5 Seconds
export const MIN_SILENCE_BEFORE_NEXT_SLIDE = 1000; // 1 Seconds
export const MAX_WAIT_BEFORE_TRY_SPEAK = 1000; // 1 Seconds

export const DELAY_BEFORE_SLIDE_MOVE_ON = 1000; // 1 Seconds

export const DEFAULT_NOTIFICATIONS_ENABLED = true;
export const DEFAULT_NOTIFICATION_LIFESPAN = 8000; // 8 Seconds
export const NOTIFICATION_SPAWN_DELAY = 3000; // 3 Seconds

export const NAVIGATION_BUTTON_DEBOUNCE_DELAY = 3000; // 2 Seconds

export const DEFAULT_Q_AND_A_SLIDE_MOVE_ON_DELAY = 6 * ONE_MINUTE_MILLIS;
export const DEFAULT_ACTIVITY_SLIDE_MOVE_ON_DELAY = 3 * ONE_MINUTE_MILLIS;


// Default Images for Welcome Slide and End of Presentation Slide
export const AI4YOUTH_WELCOME_IMAGE_URL = require( "../assets/AI4YouthWelcomeImage.png" );
export const ENRICHYA_WELCOME_IMAGE_URL = require( "../assets/EnrichyaWelcomeImage.png" );
export const DEFAULT_WELCOME_IMAGE_URL = APP == AI4YOUTH ? AI4YOUTH_WELCOME_IMAGE_URL : ENRICHYA_WELCOME_IMAGE_URL;
//export const PRESENTATION_END_IMAGE_URL = "https://cdn.mos.cms.futurecdn.net/6nYzMLXUjkaVomaBZ8sNRZ.jpg";
// TODO: ^ is not used since Database needs support endSlideImageURL field


// Audio
export const USE_BROWSER_SPEECH_SYNTHESIS_API = false;

export const DEBUG_VOICE_SPEED = 2.0; // Ranges from 0.1 to 10.0
export const VOICE_SPEED = 1.4; // Ranges from 0.1 to 10.0

export const INSTRUCTOR_VOICES = ["Yan", "Jenny", "Zira", "Samantha", "Alice"];
export const FAKE_STUDENT_VOICES = ["Roger", "Stephan", "Mark", "Aaron", "Arthur"];

// Audio Input/Output Configuration
export const ENABLE_AUDIO_OUTPUT = false; // Enable/disable text-to-speech audio playback
export const ENABLE_AUDIO_INPUT = false; // Enable/disable microphone audio capture

// Audio Output Delay Configuration (when ENABLE_AUDIO_OUTPUT = false)
export const USE_TEXT_LENGTH_BASED_DELAY = false; // If false, uses AUDIO_OUTPUT_FIXED_DELAY; if true, calculates based on text length
export const AUDIO_OUTPUT_FIXED_DELAY = 0; // Milliseconds - used when USE_TEXT_LENGTH_BASED_DELAY = false
export const AUDIO_OUTPUT_WORDS_PER_MINUTE = 175; // Average speaking speed for text-length-based delay calculation

// Instant Output Mode Detection
// When true, all chunks are output at once with no delay - used for response group highlighting
export const IS_INSTANT_OUTPUT_MODE = !ENABLE_AUDIO_OUTPUT && !USE_TEXT_LENGTH_BASED_DELAY && AUDIO_OUTPUT_FIXED_DELAY === 0;

// Chunk Delay Configuration - controls pauses between groups of chunks
export const CHUNKS_BEFORE_LONG_DELAY = 3; // Number of chunks before inserting a long delay (only applies if LONG_DELAY_DURATION > 0)
export const LONG_DELAY_DURATION = 0; // Milliseconds - delay inserted after every CHUNKS_BEFORE_LONG_DELAY chunks (0 = no delay, immediate)


// Canned Messages
export const WAIT_UNTIL_NO_ONE_SPEAKING_NOTIFICATION = "Please wait until no one is speaking before sending";
export const SLIDE_TIME_LIMIT_MESSAGE = "We'll need to move on for now to have time for more material. You'll have an opportunity to ask questions shortly.";
export const QUESTION_LIMIT_MESSAGE = "The engagement is great. Let's move on for now. You'll have another opportunity to ask questions here soon";
export const QUESTIONS_PAUSED_NOTIFICATION = "Questions are paused until the next Q&A Slide";
export const END_OF_PRESENTATION_MESSAGE = "We've reached the end of the presentation";
//export const SERVER_ERROR_TEXT =  "I'm experiencing network issues. I can continue with the lecture but I may not be able to answer questions or respond to you. Please click Previous and then Next or try again later.";
export const SERVER_ERROR_TEXT = "Sorry, I was not able to answer your question due to a technical issue. Please click Previous button and click Next button to reload the current slide. You can then ask your question again.";


// Question Limits
export const MAX_QUESTIONS_ALLOWED_PER_LECTURE_SLIDE = 3;
export const MAX_QUESTIONS_ALLOWED_PER_Q_AND_A_SLIDE = 10; // TODO: Was 10 per requirements, but 3 for testing


// Slide Type Key Phrases
export const Q_AND_A_SLIDE_KEY_PHRASE = "Q&A Slide";
export const ACTIVITY_SLIDE_KEY_PHRASE = "Activity Slide";
export const QUIZ_SLIDE_KEY_PHRASE = "Quiz Slide";

export const DEFAULT_MAX_SLIDES = 100;

export const AUTO_CHANGE_SLIDES = true;

export const FAKE_STUDENT_NAME = "Mario";
export const FAKE_STUDENT_PROFILE_PIC_SRC = require( "../assets/fake_student_1.png" );
export const FAKE_STUDENT_ASK_QUESTION_DELAY = 100; // Milliseconds
export const IDLE_FAKE_STUDENT_VIDEO = "IdleFakeStudentAnimation.mp4";

export const TEST_STUDENT_NAME = "Oliver";
export const TEST_STUDENT_VOICE = "Steffan";
export const TEST_STUDENT_PROFILE_PIC_SRC = require( "../assets/fake_student_2.png" );



export const DEBUG_SLIDE_NUMBER_START = 0;
export const SLIDE_NUMBER_START = DEBUG ? DEBUG_SLIDE_NUMBER_START : 0;



export const DEFAULT_FAKE_STUDENT_FOLLOW_UP_DELAY = 5000; // 5 Seconds
export const DEFAULT_INSTRUCTOR_FOLLOW_UP_DELAY = 10000; // 10 Seconds
export const DEFAULT_BACKGROUND_PROMPT_DELAY = 8000; // 8 Seconds

export const DEFAULT_SLIDE_MOVE_ON_DELAY = 120000; // 2 Minutes


// ============================= Slide Completion Configuration ================================
export enum SlideCompletionMode {
  IMMEDIATE = "immediate",              // Mark slide complete after fixed delay from slide start
  WAIT_FOR_ALL_TASKS = "wait_for_all_tasks"  // Mark slide complete only after all scheduled tasks finish
}

export const SLIDE_COMPLETION_MODE = SlideCompletionMode.IMMEDIATE;
export const SLIDE_COMPLETION_IMMEDIATE_DELAY = 5000; // 5 seconds - delay before marking slide complete in IMMEDIATE mode
export const SLIDE_COMPLETION_WAIT_BUFFER = 1000; // 1 second - small buffer after last task in WAIT_FOR_ALL_TASKS mode
// =========================================================================================


// ============================= Spinner Display Configuration ================================
export enum SpinnerDisplayMode {
  INLINE = "inline",                    // Show spinner inline within the component
  CHAT_OVERLAY = "chat-overlay",        // Show spinner overlaying the chat container
  PRESENTATION_OVERLAY = "presentation-overlay", // Show spinner overlaying the presentation/lecture container
  SCREEN_OVERLAY = "screen-overlay"     // Show spinner as full-screen overlay
}

export enum SpinnerOpacityLevel {
  HIGH = "high",     // Most opaque (current level)
  MEDIUM = "medium", // Moderate opacity
  LOW = "low",       // Most transparent
  NONE = "none"      // No background overlay
}

// ============================= Configuration Options ================================
// Chat Spinner Configuration
export const CHAT_SPINNER_DISPLAY_MODE = SpinnerDisplayMode.SCREEN_OVERLAY;
export const CHAT_SPINNER_OPACITY_LEVEL = SpinnerOpacityLevel.NONE;

// App State Spinner Configuration  
export const APP_STATE_SPINNER_DISPLAY_MODE = SpinnerDisplayMode.SCREEN_OVERLAY;
export const APP_STATE_SPINNER_OPACITY_LEVEL = SpinnerOpacityLevel.HIGH;

// ============================= Example Configurations ================================
// THE BELOW ARE SOME EXAMPLES OF WHAT YOU CAN DO WITH THE SPINNER CONFIGURATIONS
// ... SAVING TESTING I DONE FOR SAKE OF FUTURE REFERENCE
//
// Example 1: Full screen overlay with high opacity (current default)
// export const CHAT_SPINNER_DISPLAY_MODE = SpinnerDisplayMode.SCREEN_OVERLAY;
// export const CHAT_SPINNER_OPACITY_LEVEL = SpinnerOpacityLevel.HIGH;
// export const APP_STATE_SPINNER_DISPLAY_MODE = SpinnerDisplayMode.SCREEN_OVERLAY;
// export const APP_STATE_SPINNER_OPACITY_LEVEL = SpinnerOpacityLevel.HIGH;
//
// Example 2: Chat container overlay with medium opacity
// export const CHAT_SPINNER_DISPLAY_MODE = SpinnerDisplayMode.CHAT_OVERLAY;
// export const CHAT_SPINNER_OPACITY_LEVEL = SpinnerOpacityLevel.MEDIUM;
//
// Example 3: Presentation container overlay with low opacity (for retrying states)
// export const APP_STATE_SPINNER_DISPLAY_MODE = SpinnerDisplayMode.PRESENTATION_OVERLAY;
// export const APP_STATE_SPINNER_OPACITY_LEVEL = SpinnerOpacityLevel.LOW;
//
// Example 4: Inline display (original behavior)
// export const CHAT_SPINNER_DISPLAY_MODE = SpinnerDisplayMode.INLINE;
// (No opacity needed for inline mode)
//
// Example 5: Mixed configuration - chat overlay + screen overlay for app states
// export const CHAT_SPINNER_DISPLAY_MODE = SpinnerDisplayMode.CHAT_OVERLAY;
// export const CHAT_SPINNER_OPACITY_LEVEL = SpinnerOpacityLevel.MEDIUM;
// export const APP_STATE_SPINNER_DISPLAY_MODE = SpinnerDisplayMode.SCREEN_OVERLAY;
// export const APP_STATE_SPINNER_OPACITY_LEVEL = SpinnerOpacityLevel.HIGH;
// =============================================================================






export const DEBUG_SERVER_ORIGIN = "https://ai4youth.org:3003";

// NOTE: Heroku assigns PORT number automatically and handles routing Requests approrpiately -- Need not include ourselves (at least not on Client)
//export const PROD_AI4YOUTH_SERVER_ORIGIN = "https://ai4youth.org/aiinstructor"; // PROD_TODO: Change this to the Server's Domain
//export const PROD_AI4YOUTH_SERVER_ORIGIN = "https://aiinstructor-dfb5c74cdf96.herokuapp.com"; // PROD_TODO: TEMPORARY FOR TESTING
export const PROD_AI4YOUTH_SERVER_ORIGIN = "https://app.ai4youth.org";
export const QA_AI4YOUTH_SERVER_ORIGIN = "https://qa.ai4youth.org";

export const PROD_ENRICHYA_SERVER_ORIGIN = "https://app.enrichya.org";
export const QA_ENRICHYA_SERVER_ORIGIN = "https://qa.enrichya.org";

//export const PORT = process.env.PORT || 3003; // NOTE: PORT is not needed here for Client. Heroku Dynamically assigns Port for Server so not clear the Port -- Default should be fine?


const getServerOrigin = () => {
    switch( APP ) {
        case AI4YOUTH:
            return DEBUG ? DEBUG_SERVER_ORIGIN : (ENVIRONMENT == PROD ? PROD_AI4YOUTH_SERVER_ORIGIN : QA_AI4YOUTH_SERVER_ORIGIN);
        case ENRICHYA:
            return DEBUG ? DEBUG_SERVER_ORIGIN : (ENVIRONMENT == PROD ? PROD_ENRICHYA_SERVER_ORIGIN : QA_ENRICHYA_SERVER_ORIGIN);
        default:
            return DEBUG_SERVER_ORIGIN;
    }
}
const getServerWebsocketsOrigin = () => {
    switch( APP ) {
        case AI4YOUTH:
            return DEBUG ? "wss://ai4youth.org:3003" : "wss://ai4youth.org";
        case ENRICHYA:
            return DEBUG ? "wss://enrichya.org:3003" : "wss://enrichya.org";
        default:
            return "wss://ai4youth.org:3003";
    }
}

export const SERVER_ORIGIN = getServerOrigin();
export const SERVER_WEBSOCKETS_ORIGIN = getServerWebsocketsOrigin();





export {};
